module.exports = __webpack_public_path__ + "staticmedia/media/OpenSans-Semibold.33f225b8.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/fonts/OpenSans-Semibold.ttf
// module id = 108
// module chunks = 0